import request from '@/utils/request'

export function getMemorialPage(params) {
  return request({
    url: '/admin/memorial/page',
    method: 'get',
    params
  })
}

export function getMemorialList(params) {
  return request({
    url: '/admin/memorial/list',
    method: 'get',
    params
  })
}

export function getMemorialDetail(id) {
  return request({
    url: `/admin/memorial/${id}`,
    method: 'get'
  })
}

export function createMemorial(data) {
  return request({
    url: '/admin/memorial',
    method: 'post',
    data
  })
}

export function updateMemorial(data) {
  return request({
    url: '/admin/memorial',
    method: 'put',
    data
  })
}

export function deleteMemorial(ids) {
  return request({
    url: '/admin/memorial',
    method: 'delete',
    data: ids
  })
}

export function updateMemorialStatus(id, status) {
  return request({
    url: `/admin/memorial/${id}/status`,
    method: 'put',
    params: { status }
  })
}

export function getMemorialStatistics(params) {
  return request({
    url: '/admin/memorial/statistics',
    method: 'get',
    params
  })
}

export function uploadMemorialImage(data, onUploadProgress) {
  return request({
    url: '/admin/memorial/upload',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 600000,
    onUploadProgress
  })
}

export function getUserMemorials(userId) {
  return request({
    url: `/admin/memorial/user/${userId}`,
    method: 'get'
  })
}

export function addMemorialsToUser(userId, memorialIds) {
  return request({
    url: `/admin/memorial/user/${userId}/add`,
    method: 'post',
    data: memorialIds
  })
}
